/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import getColor from "@insite/mobius/utilities/getColor";
import { viewStyles } from "@monsma/Overrides/Widgets/ProductDetails/ProductDetailsView";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

const rightMiddleHiddenCss = css`
    width: 100%;
    direction: ltr;
    background: ${getColor("common.background")};
    border: 1px solid ${getColor("common.ui12")};
    padding: 20px 20px 25px;
    border-radius: 6px;
`;

viewStyles.container = {
    gap: 0,
    css: css`
        padding-top: 20px;
        direction: rtl;
    `,
};

viewStyles.leftColumnInnerContainer = {
    gap: 0,
};

viewStyles.rightColumnGridItem = {
    width: [0, 0, 0, 4, 4],
    css: css`
        &&& {
            padding-left: 60px;

            &.not-authorized {
                @media print {
                    display: none;
                }
            }
        }
    `,
};

viewStyles.rightColumnGridItemHidden = {
    below: "md",
    css: css`
        ${rightMiddleHiddenCss};

        ${screen("gt", "md")} {
            position: sticky;
            top: 180px;
        }
    `,
};

viewStyles.middleGridItemHidden = {
    above: "md",
    css: css`
        ${rightMiddleHiddenCss};
    `,
};

(viewStyles as any).imageInfoWrapper = {
    css: css`
        display: flex;
        flex-flow: row wrap;
    `,
};

(viewStyles as any).imageWrapper = {
    css: css`
        ${screen("gt", "540")} {
            width: 230px;
            margin-right: 46px;
        }

        ${screen("lte", "540")} {
            margin-bottom: 40px;
            width: 100%;
        }
    `,
};

(viewStyles as any).infoWrapper = {
    css: css`
        flex: 1;
        display: flex;

        > div {
            display: flex;
            flex-direction: column;
        }
    `,
};

(viewStyles as any).msrpPrice = {
    css: css`
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        h3 {
            margin-bottom: 0;
            margin-right: 5px;
        }
    `,
};

(viewStyles as any).notAuthorizedMessage = {
    css: css`
        display: flex;
        margin-bottom: 33px;

        p {
            margin-bottom: 0;
            font-size: 13px;
        }

        span {
            margin: 5px 9px 0 0;
        }
    `,
};

(viewStyles as any).notAuthorizedNotice = {
    css: css`
        font-size: 13px;
        line-height: 20px;
        font-weight: 600;
        padding-bottom: 20px;
        border-bottom: 1px solid ${getColor("common.ui12")};
        margin-bottom: 20px;

        @media print {
            border-bottom: unset;
            margin-bottom: unset;
            padding-bottom: unset;
        }
    `,
};

viewStyles.middleGridItem = {
    ...viewStyles.middleGridItem,
    width: [12, 12, 12, 0, 0],
    css: css`
        &&& {
            @media print {
                margin-bottom: 30px;
            }
        }
    `,
};

viewStyles.leftColumnGridItem = {
    ...viewStyles.leftColumnGridItem,
    printWidth: 12,
    width: [12, 12, 12, 8, 8],
    css: css`
        &&& {
            ${viewStyles.leftColumnGridItem?.css};

            @media print {
                display: block;
                max-width: 100%;
                page-break-before: avoid;
                break-before: avoid;
            }
        }
    `,
};

viewStyles.topGridItem = {
    ...viewStyles.topGridItem,
    css: css`
        &&& {
            ${screen("lte", "md")} {
                margin-bottom: 40px;
            }

            @media print {
                margin-bottom: 30px;
            }
        }
    `,
};

viewStyles.bottomGridItem = {
    ...viewStyles.bottomGridItem,
    css: css`
        &&& {
            @media print {
                display: block;
            }
        }
    `,
};

viewStyles.productAvailabilityText = {
    variant: "p",
    lineHeight: "20px",
};
